 
const gallery = {
    namespaced: true,
    state: () => ({
        all:{data:[]},
        user_gallery:{data:[]},
        photographers:JSON.parse(localStorage.getItem('photographers')) || [],
        todayPhoto:JSON.parse(localStorage.getItem('todayPhoto')) || []
      }),
      mutations:{
         updategalleryState(state,data){
            state.all.data;
           var items=state.all.data;
            for (let index = 0; index < data.data.length; index++) {
                const element = data.data[index];
                items.push(element)
                
              }
              state.all.data=items;
         },
         updateUsergalleryState(state,data){
           var items=state.user_gallery.data;
            for (let index = 0; index < data.data.length; index++) {
                const element = data.data[index];
                items.push(element)  
              }
              state.user_gallery.data=items;
         },
         clearContents(state,data){
           state.all=data;
         },
         clearUserContents(state,data){
           state.user_gallery=data;
         },
         updatePhotographersState(state,data){
              state.photographers=data;
              localStorage.setItem('photographers',JSON.stringify(state.photographers))
         },
         updateTodayPhotoState(state,data){
            state.todayPhoto= data;
            localStorage.setItem('todayPhoto',JSON.stringify(data))
         }
      },
      actions: {
        fetchgallery({commit},{page,category=0,user=0,sort='add_desc',limit=20,featured=0,pic_week=0,query='',clear=false}){
            fetch(`https://pic.imamhussain.org/index.php/api/v2/photos?page=${page}&category=${category}&user=${user}&sort=${sort}&limit=${limit}&featured=${featured}&pic_week=${pic_week}&query=${query}`).then(res=>res.json()).then(res=>{
              if (clear) {
                commit('clearContents',res)
              }else{
                commit('updategalleryState',res)
              }
            });
        },
        fetchUsergallery({commit},{page,category=0,user=0,sort='add_desc',limit=20,featured=0,pic_week=0,query='',clear=false}){
            fetch(`https://pic.imamhussain.org/index.php/api/v2/photos?page=${page}&category=${category}&user=${user}&sort=${sort}&limit=${limit}&featured=${featured}&pic_week=${pic_week}&query=${query}`).then(res=>res.json()).then(res=>{
              if (clear) {
                commit('clearUserContents',res)
              }else{
                commit('updateUsergalleryState',res)
              }
            });
        },
        fetchPhotographers({commit},{page,limit=100}){
            fetch(`https://pic.imamhussain.org/index.php/photographers?page=${page}&limit=${limit}`).then(res=>res.json()).then(res=>{commit('updatePhotographersState',res.data)});
        },
        fetchTodayPhoto({commit}){
            fetch(`https://pic.imamhussain.org/index.php/api/v2/photos?pic_week=1&sort=add_desc`).then(res=>res.json()).then(res=>{commit('updateTodayPhotoState',res.data)});
        },
      },
    
      getters: {  
      }
}

export default gallery;